// 所有的icon数据

const memory = [
  '山火灾害-icons.jpg-0',
  '南昌舰入列-icons.jpg-1',
  '赵忠祥去世-icons.jpg-2',
  '曼巴陨落 科比离世-icons.jpg-3',
  '延长2020春节假期-icons.jpg-4',
  '宅家就是做贡献-icons.jpg-5',
  '英国正式“脱欧”-icons.jpg-6',
  '全民网课-icons.jpg-57',
  '云监工-icons.jpg-7',
  '致敬最美逆行者-icons.jpg-8',
  '山川异域，风月同天-icons.jpg-9',
  '张伟丽成功卫冕金腰带-icons.jpg-10',
  '汽、柴油进入 “5元时代”-icons.jpg-11',
  '美股熔断4次-icons.jpg-12',
  '东京奥运会延期举办-icons.jpg-13',
  '半年没进过电影院-icons.jpg-59',
  '全国人民默哀三分钟-icons.jpg-14',
  '个税退税-icons.jpg-15',
  '高考推迟-icons.jpg-16',
  '爱上一款游戏-icons.jpg-67',
  '武汉解封-icons.jpg-17',
  '淡黄的长裙，蓬松的头发-icons.jpg-60',
  '负油价-icons.jpg-18',
  '做核酸检测-icons.jpg-61',
  '五月召开的全国两会-icons.jpg-19',
  '重返珠峰之巅测高-icons.jpg-20',
  '“黑人的命也是命”-icons.jpg-21',
  '《后浪》-icons.jpg-22',
  '周杰伦夏日特调《Mojito》-icons.jpg-23',
  'Uzi退役-icons.jpg-24',
  '超级日环食-icons.jpg-25',
  '海南建设自由贸易港-icons.jpg-26',
  '航班熔断-icons.jpg-27',
  '微信“拍一拍”-icons.jpg-62',
  '北斗组网-icons.jpg-28',
  '《隐秘的角落》-icons.jpg-29',
  '看线上演唱会-icons.jpg-63',
  '天问一号发射成功-icons.jpg-30',
  '南方暴雨-icons.jpg-31',
  '云毕业-icons.jpg-32',
  '香港国安法颁布-icons.jpg-33',
  '直播间下单-icons.jpg-64',
  '致敬“共和国勋章”获得者钟南山-icons.jpg-34',
  '捞了一夏天的五条人-icons.jpg-35',
  '安倍晋三辞职-icons.jpg-36',
  '申纪兰去世-icons.jpg-37',
  '喝到秋天的第一杯奶茶-icons.jpg-38',
  '《外卖骑手，困在系统里》-icons.jpg-39',
  '追《乘风破浪的姐姐》-icons.jpg-40',
  '“烧脑”的《信条》-icons.jpg-41',
  '看了一部国庆档影片-icons.jpg-42',
  '迎接志愿军烈士遗骸回家-icons.jpg-43',
  '特朗普夫妇感染新冠病毒-icons.jpg-44',
  '追更蒙古国赠送的3万只羊-icons.jpg-45',
  '为球王马拉多纳哭泣-icons.jpg-46',
  '使用微信新表情-icons.jpg-47',
  '点赞“甜野男孩”丁真-icons.jpg-48',
  '成为双十一尾款人-icons.jpg-49',
  '围观美国大选-icons.jpg-50',
  'RCEP签署-icons.jpg-51',
  '凡尔赛文学-icons.jpg-52',
  '832个国家级贫困县全部脱贫摘帽-icons.jpg-53',
  '“十四五”规划和2035年远景目标建议-icons.jpg-54',
  '参与“光盘行动”-icons.jpg-65',
  '看嫦娥五号去月球“挖土”-icons.jpg-55',
  '“马首”回归圆明园-icons.jpg-56',
  '“奋斗者”号成功挑战万米深海-icons.jpg-58',
  '数字人民币-icons.jpg-66'
]
const icons = []
const publicPath = process.env.NODE_ENV === 'production' ? '/node/2020recall/' : '/'
// [{
// id: 0,
// icon: '1.png',
// text: '云毕业',
// status: false // 选中，或者非选中
// }, {
// id: 1,
// icon: '1.png',
// text: '云毕业',
// status: false // 选中，或者非选中
// }, {
// id: 2,
// icon: '1.png',
// text: '云毕业',
// status: false // 选中，或者非选中
// }]
for (let i = 0; i < memory.length; i++) {
  const data = memory[i].split('-')

  icons.push({
    id: i,
    icon: publicPath + 'img/memory/' + data[1],
    path: data[2],
    text: data[0],
    status: false
  })
}

export default icons
